<template>
  <!-- password START -->
  <div class="reset-password">

    <!-- sms:password:headline:description START -->
    <div class="headline-description">
      <h1 v-html="`${$t('sms.resetpassword.headline')}`"></h1>
      <div class="description" v-html="`${$t('sms.resetpassword.description')}`"></div>
    </div>
    <!-- sms:password:headline:description END -->

    <!-- form:password START -->
    <el-form
      status-icon
      :rules="rules"
      ref="registerForm"
      :model="registerForm"
      class="login-form"
      :statusIcon="false"
      @submit.prevent.native="executeRecaptcha"
    >
      <!-- form:password:new-password START -->
      <el-form-item prop="password">
        <el-input
          :type="type"
          :placeholder="`${$t('login.password')} *`"
          v-model="registerForm.password"
          @keyup.enter.native="executeRecaptcha"
          autocomplete="off"
        >
          <i
            slot="suffix"
            class="el-icon-view"
            v-on:click="showHidePassword()"
          ></i>
        </el-input>
      </el-form-item>
      <!-- form:password:new-password END -->

      <!-- form:password:confirm-password START -->
      <el-form-item prop="confirmPassword">
        <el-input
          :type="type"
          :placeholder="`${$t('login.confirmpassword')} *`"
          v-model="registerForm.confirmPassword"
          @keyup.enter.native="executeRecaptcha"
          autocomplete="off"
        >
          <i
            slot="suffix"
            class="el-icon-view"
            v-on:click="showHidePassword()"
          ></i>
        </el-input>
      </el-form-item>
      <!-- form:password:confirm-password END -->

      <!-- form:password:submit START -->
      <el-form-item>
        <el-button
          class="btn-default"
          type="primary"
          v-on:click="executeRecaptcha"
        >{{ $t('login.resetpassword') }}</el-button>

      </el-form-item>
      <!-- form:password:submit END -->

      <!-- form:google-recaptcha:submit START -->
      <recaptcha
        ref="recaptcha"
        v-on:verify="verifyForm"
      ></recaptcha>
      <!-- form:google-recaptcha:submit END -->

    </el-form>
    <!-- form:password END -->

    <!-- form:password:loading START -->
    <loading-default
      :loadingVisible="loadingVisible"
      :headline="loadingHeadline"
      :excerpt="loadingExcerpt"
    />
    <!-- form:password:loading END -->

  </div>
  <!-- password END -->
</template>

<script>
import validateMixin from '@/mixins/validateMixin';

export default {
  name: 'reset-password',
  mixins: [validateMixin],
  components: {
    LoadingDefault: () => import('../components/shared/loading/Default.vue'),
    Recaptcha: () => import('../components/shared/Recaptcha.vue'),
  },
  data() {
    return {
      googleRecaptchaToken: '',
      /**
       * Params
       */
      userToken: this.$route.query ? this.$route.query.token : undefined,
      userLang: this.$route.query ? this.$route.query.locale : undefined,

      /**
       * Loading
       */
      loadingVisible: false,
      loadingHeadline: this.$t('loading.update.headline'),
      loadingExcerpt: this.$t('loading.update.excerpt'),

      /**
       * Form (Variables)
       */
      serverErrorMessages: [],
      globalErrorMessage: false,
      type: 'password',
      oldType: 'password',

      /**
       * Form (Models) + Pass data to mixin
       */
      messagePassword: this.$t('login.messagepassword'),
      confirmationPassword: this.$t('login.confirmationpassword'),
      registerForm: {
        password: '',
        confirmPassword: '',
      },
      /**
       * Form (Rules - Validation)
       */
      rules: {
        password: [
          {
            required: true,
            message: this.$t('login.errorformfield'),
            trigger: [
              'blur',
              'change',
            ],
          },
          {
            validator: this.validatePassword,
            trigger: [
              'blur',
              'change',
            ],
          },
        ],
        confirmPassword: [
          {
            required: true,
            message: this.$t('login.errorformfield'),
            trigger: [
              'blur',
              'change',
            ],
          },
          {
            validator: this.validateConfirmPassword,
            trigger: [
              'blur',
              'change',
            ],
          },
        ],
      },
    };
  },
  methods: {
    submitForm(formName) {
      const formData = new FormData();
      if (formName === 'registerForm') {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.loadingVisible = true;
            /**
             * Locale
             */
            if (this.userLang !== undefined) {
              formData.append('locale', this.userLang);
            } else {
              formData.append('locale', 'de_AT');
            }
            /**
             * Data
             */
            if (this.userToken !== undefined) {
              formData.append('token', this.userToken);
            }
            formData.append('password', this.registerForm.password);
            formData.append('repassword', this.registerForm.confirmPassword);
            formData.append('g-recaptcha-response', this.googleRecaptchaToken);

            // Update user data
            this.$http.post(`${process.env.VUE_APP_BASE_URL}/passwordByToken`, formData, {
              headers: {
                'X-Api-Key': `${process.env.VUE_APP_X_API_KEY}`,
              },
            })
              .then((response) => {
                if (response.data) {
                  this.loadingVisible = false;

                  // notification - error
                  this.success();

                  // delete created notification dom element
                  setTimeout(() => {
                    if (document.querySelector('.el-notification')) {
                      const elem = document.querySelector('.el-notification');
                      elem.remove();
                    }
                  }, 6500);
                } else {
                  this.globalErrorMessage = true;
                  this.resetForm.agbs = false;

                  console.log('error register submit!!');
                }
              })
              .catch((error) => {
                if (!error.response) {
                  // network error
                  this.errorStatus = 'Error: Network Error';
                } else {
                  this.errorStatus = error.response.data;
                  this.serverErrorMessages = this.errorStatus.errors;

                  console.clear();

                  this.loadingVisible = false;

                  this.serverErrorMessages.forEach((message) => {
                    this.error(`${this.$t(`error.${message.code}`)}`);
                  });
                }
              });
          }
        });
      }
    },

    resetForm(formName) {
      if (this.$refs[formName]) {
        this.globalErrorMessage = false;
        this.$refs[formName].resetFields();
        this.type = 'password';
      }
    },

    showHidePassword() {
      if (this.type === 'password') {
        this.type = 'text';
      } else {
        this.type = 'password';
      }
    },

    showHidePasswordOld() {
      if (this.oldType === 'password') {
        this.oldType = 'text';
      } else {
        this.oldType = 'password';
      }
    },

    updateItem(item, value) {
      const prevData = JSON.parse(localStorage.getItem(item));
      Object.keys(value).forEach((val) => {
        prevData[val] = value[val];
      });
      localStorage.setItem(item, JSON.stringify(prevData));
    },

    success() {
      this.$notify({
        message: this.$t('error.sentifexists'),
        type: 'success',
        position: 'bottom-right',
      });

      // clean up input fields
      setTimeout(() => {
        this.resetForm('resetPasswordForm');
      }, 750);
    },

    error(message) {
      this.$notify({
        message: this.$t(`${message}`),
        type: 'error',
        position: 'bottom-right',
      });
    },

    verifyForm(googleRecaptchaResponse) {
      if (googleRecaptchaResponse) {
        this.googleRecaptchaToken = googleRecaptchaResponse;
        this.submitForm('registerForm');
      }
    },

    executeRecaptcha() {
      this.$refs.recaptcha.execute();
    },
  },
};
</script>
